import { createSelector } from '@reduxjs/toolkit';
import { sportsAdapter } from '~SpectateStore/slices/sportsSlice';
import { selectEventSportId } from './eventsSelectors';

export const {
    selectById: selectSportById,
} = sportsAdapter.getSelectors(state => state.sports);

export const selectSportName = (state, sportId) => selectSportById(state, sportId)?.name;
export const selectSportSlug = (state, sportId) => selectSportById(state, sportId)?.slug;

export const selectSportSlugByEventId = createSelector(
    [
        state => state,
        selectEventSportId,
    ],
    (state, sportId) => selectSportSlug(state, sportId),
);
